import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import moment from 'moment';
import {
    HeaderTextContainer1,
    HeaderTextContainer2,
    HeaderTextContainer3,
    To,
    UserContainer,
    ValidContainer,
    CloseIcon,
    From,
    Line,
    Container,
    ContainerGrid,
    HeaderTextContainer4,
    HeaderTextContainer5,
    User,
    Username,
    Designation,
    Container1,
    ContainerGrid1,
    Container2,
    TextBold,
    BottomNavigationButtonContainer,
    UpdateProxyPopupContainer,
    RadiobuttonContainer,
} from './index.styled';
import UserEmphasis from 'src/assets/images/UserEmphasis.svg';
import Datepicker from 'src/common/components/datePicker/DatePicker';
import Calendar from 'src/assets/images/CalendarTodayBlue.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    setUnsavedChange,
    setCommonCancel,
    setIsEdit,
} from 'src/pages/more/redux/actions/index.js';
import { useTranslation } from 'react-i18next';
import { addProxies, getAdminProxyUsers } from 'src/pages/admin/redux/action';
import { isMobileDevice, logErrorToConsole } from 'src/utils/util';
import { getDisplayDate, getPlaceholderDateFormat } from 'src/utils/dateUtils';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import { BASE_TEXT_PX, FONT_FAMILY_REGULAR } from 'src/styles/fonts/MCFontConstants';
import { VISIBLE } from 'src/constants/appConstants';
import PaginatedAutocomplete from 'src/pages/more/pages/proxies/addProxy/PaginatedAutocomplete.jsx';

import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const AddProxy = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [selectedUser, setselectedUser] = useState('');
    const [warningMessage, setWarningMessage] = useState(false);
    const [apply, setApply] = useState(false);
    const [isAlreadyClicked, seIsAlreadyClicked] = useState(false);
    const [isOption, setIsOption] = useState(true);
    const [districtType, setDistrictType] = useState('within'); // Radio button state: 'within' or 'outside'

    useEffectWithErrorLogging(() => {
        dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: false, page: 0 }));
        return()=>{
            dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: false, page: 0 }));
        };
    }, []);
    const adminUsers = useSelector(
        (state) => state.AdminProxyReducer.proxyUserList.userList
    );
    const proxyRadioButton = useSelector((state) => state.loginReducer.proxyRadioButton);
    const filtredObj =
        adminUsers && adminUsers.filter((user) => user.employeeRole);

    const options =
        filtredObj &&
        filtredObj
            .filter((user) => user.employeeRole !== 'Un-assigned')
            .map((item) => {
                return {
                    label: `${item.lastName}, ${item.firstName}`,

                    id: item && item.employeeRole,
                    value: item && item.uid,
                };
            });

    const [selectedOption, setselectedOption] = useState(
        t('admin.addProxy.index.selectAUser')
    );
    const [selectedStartDate, setselectedStartDate] = useState(
        moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]HH:mm:ss')
    );
    const [selectedEndDate, setselectedEndDate] = useState('');
    const handleChange = (selectedOption) => {
        if (selectedOption.uid !== t('admin.addProxy.index.selectAUser')) {
            setWarningMessage(false);
        }
        setApply(true);
        const clickeddOption = options.filter(
            (v) => v.value === selectedOption.uid
        );

        setselectedUser(clickeddOption[0].value);
        dispatch(setUnsavedChange(true));
        setselectedOption(selectedOption.uid);
    };
    const onSave = () => {
        seIsAlreadyClicked(true);
        setTimeout(() => {
            try {
                seIsAlreadyClicked(false);
            } catch (error) {
                logErrorToConsole(error);
            }
        }, 600);
        if (selectedOption === t('admin.addProxy.index.selectAUser')) {
            setWarningMessage(true);
        }
        let params = {
            startDate: moment(selectedStartDate).format('MM-DD-YYYY'),

            endDate:
                selectedEndDate === ''
                    ? ''
                    : moment(selectedEndDate).format('MM-DD-YYYY'),
            uid: selectedUser,
            proxyForUid: props.addProxyData.userId,
        };
        dispatch(addProxies(params));
        dispatch(setIsEdit(false));
    };
    const onCancel = () => {
        dispatch(setCommonCancel(true));
        dispatch(setIsEdit(false));
        props.handleClose();
    };

    const handleInputStartDateChange = (date) => {
        if (date === '') {
            setselectedStartDate(
                moment(new Date().setHours(0, 0, 0, 0)).format('MM-DD-YYYY')
            );
        } else {
            setselectedStartDate(date);
        }
    };
    const handleInputEndDateChange = (date) => {
        setselectedEndDate(date);
    };
    return (
        <>
            <UpdateProxyPopupContainer>
                <Container1
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    alignItems="center"
                >
                    <ContainerGrid1
                        item
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        mobile={6}
                    >
                        {warningMessage && (
                            <span
                                style={{
                                    color: 'red',
                                    fontSize: '12px',
                                    fontFamily: 'AvenirNextWorld Regular',
                                }}
                            >
                                {t('admin.')}
                            </span>
                        )}
                        <HeaderTextContainer1>
                            {t('proxies.addAProxy.title')}
                        </HeaderTextContainer1>
                    </ContainerGrid1>
                    <ContainerGrid1
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={6}
                    >
                        <CloseIcon
                            id="admin-index-addProxy-closeButton"
                            mobilePath={Close}
                            onClick={props.handleClose}
                            show={true}
                        />
                    </ContainerGrid1>
                </Container1>
                <HeaderTextContainer2>
                    {t('proxies.addAProxy.heading')}
                </HeaderTextContainer2>

                <HeaderTextContainer5
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    mobile={6}
                >
                    {t('admin.addProxy.proxyFor')}
                </HeaderTextContainer5>
                <div
                    style={{
                        margin: 'auto',
                        display: 'inline-flex',
                        padding: '11.88px 0 0 0',
                    }}
                >
                    <img
                        src={UserEmphasis}
                        alt={'.png'}
                        width={'31.7px'}
                        height={'31.7px'}
                    />
                    <User style={{ marginTop: '-9px' }}>
                        <Username className="admin-person-name-dt-mask">
                            {props?.addProxyData?.firstName}{' '}
                            {props?.addProxyData?.lastName}
                        </Username>
                        <Designation
                            style={{
                                paddingLeft: isMobileDevice ? '3px' : '0px',
                            }}
                        >
                            {props?.addProxyData?.userRoles}
                        </Designation>
                    </User>
                </div>
                {/* District Type Radio Buttons */}
                {proxyRadioButton === VISIBLE && <RadiobuttonContainer>
                    <RadioButton
                        isChecked={districtType === 'within'}
                        id={'admin-addproxy-within-district'}
                        label={t('proxies.withinDistrict')}
                        handleChange={() => {
                            districtType!=='within'&&setApply(false);
                            setDistrictType('within');
                            setIsOption(true);
                            dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: false }));
                        }}
                        fontFamilyStyle={FONT_FAMILY_REGULAR}
                        fontSize={BASE_TEXT_PX}
                        style={{
                            paddingLeft: '28px',
                        }}
                        width={'14px'}
                    />
                    <RadioButton
                        isChecked={districtType === 'outside'}
                        id={'admin-addproxy-outside-district'}
                        label={t('proxies.outsideDistrict')}
                        handleChange={() => {
                            districtType!=='outside'&&setApply(false);
                            setDistrictType('outside');
                            setIsOption(true);
                            dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: true, page: 0 }));
                        }}
                        fontFamilyStyle={FONT_FAMILY_REGULAR}
                        fontSize={BASE_TEXT_PX}
                        style={{
                            paddingLeft: '28px',
                        }}
                        width={'14px'}
                    />
                </RadiobuttonContainer>}
                <UserContainer>
                    <HeaderTextContainer3
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        mobile={6}
                    >
                        {t('proxies.addAProxy.user')}{' '}
                        <span style={{ color: '#FF0000' }}> * </span>
                    </HeaderTextContainer3>

                    <Container2>
                        <PaginatedAutocomplete setIsOption={setIsOption} isOption={isOption}handleChange={handleChange} districtType={districtType} props={props} setApply={setApply} isAdminScreen={true} id={'adminProxy-addProxy-userList'}/>
                    </Container2>
                </UserContainer>
                <ValidContainer>
                    <HeaderTextContainer4 validDate>
                        {t('proxies.addAProxy.validDates')}
                    </HeaderTextContainer4>

                    <Container
                        container
                        justifyContent={'space-between'}
                        direction="row"
                    >
                        <ContainerGrid
                            item
                            xs={12}
                            sm={3}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={12}
                        >
                            <From>
                                {t('proxies.addAProxy.from')}{' '}
                                <span style={{ color: '#FF0000' }}> * </span>
                            </From>
                            <Container2>
                                <Datepicker
                                    datePickerCalendarIcon={Calendar}
                                    minDate={new Date()}
                                    maxDate={
                                        selectedEndDate != ''
                                            ? selectedEndDate
                                            : ''
                                    }
                                    placeholder={getDisplayDate(new Date())}
                                    fontSize="16px"
                                    left="10px"
                                    iconRight="0"
                                    mobileHeight="40px"
                                    datePickerDivMbWidth="217px"
                                    datePickerDivMbHeight="40px"
                                    yearRange={`${new Date().getFullYear()}:2999`}
                                    datePickerBgColor="#FFFFFF"
                                    datePickerDivWidth="200px"
                                    datePickerDivHeight="40px"
                                    iconHeight={'auto'}
                                    border={'2px solid #EBEDED'}
                                    textOpacity={0.5}
                                    Zindex={99999}
                                    onChange={(date) =>
                                        handleInputStartDateChange(date)
                                    }
                                    selectedDateFromDatePicker={
                                        selectedStartDate
                                    }
                                />

                                <div
                                    style={{ position: 'relative !important' }}
                                />
                            </Container2>
                        </ContainerGrid>
                        <ContainerGrid
                            item
                            xs={12}
                            sm={3}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={12}
                            key="accountName"
                            ipadMarginRight={'8% !important'}
                        >
                            <To>
                                {t('proxies.addAProxy.to')}{' '}
                                {/* <span style={{ color: '#FF0000' }}> * </span> */}
                            </To>
                            <Container2>
                                <Datepicker
                                    datePickerCalendarIcon={Calendar}
                                    minDate={new Date(selectedStartDate)}
                                    // maxDate={new Date()}
                                    placeholder={getPlaceholderDateFormat()}
                                    fontSize="16px"
                                    left="10px"
                                    iconRight="0"
                                    datePickerDivMbWidth="217px"
                                    datePickerDivMbHeight="40px"
                                    mobileHeight="40px"
                                    yearRange={`${new Date().getFullYear()}:2999`}
                                    datePickerBgColor="#FFFFFF"
                                    datePickerDivWidth="200px"
                                    datePickerDivHeight="40px"
                                    iconHeight={'auto'}
                                    border={'2px solid #EBEDED'}
                                    textOpacity={0.5}
                                    Zindex={99999}
                                    onChange={(date) =>
                                        handleInputEndDateChange(date)
                                    }
                                    selectedDateFromDatePicker={selectedEndDate}
                                />
                                <div
                                    style={{ position: 'relative !important' }}
                                />
                            </Container2>
                        </ContainerGrid>
                    </Container>
                </ValidContainer>
                <Line></Line>
                <BottomNavigationButtonContainer
                    ipadPadding={'0px 27px 0px 0px'}
                    mbPadding={'10px 0px 0px'}
                    adminproxy
                >
                    <Button
                        id={'page-admin-addProxy-cancel'}
                        clearNotes
                        show={true}
                        //cancel={true}
                        variant={ButtonStyles?.cancel}
                        width={'102px'}
                        height={'38px'}
                        margin={'16px 4px 0px 4px'}
                        mobileMargin={'15px 5px 10px 10px'}
                        clicked={onCancel}
                    >
                        <TextBold color={'#140F4B'}>
                            {t('proxies.addAProxy.cancel')}
                        </TextBold>
                    </Button>
                    <Button
                        id={'page-admin-addProxy-apply'}
                        show
                        // primary={true}
                        variant={apply ? ButtonStyles?.primary : ButtonStyles?.disabled}
                        //primary={apply ? true : false}
                        // {!warningMessage ? true : false}
                        // disabledSaveBtn={
                        //     apply && !isAlreadyClicked ? false : true
                        // }
                        // {warningMessage ? true : false}
                        disabled={apply && !isAlreadyClicked ? false : true}
                        // {warningMessage}
                        width={'102px'}
                        height={'38px'}
                        fontSize={'15px'}
                        mobileMargin={'15px 3px 10px 10px'}
                        margin={'16px 4px 0px 4px'}
                        clicked={onSave}
                    >
                        <TextBold color={'#FFFF'}>
                            {t('proxies.addAProxy.save')}
                        </TextBold>
                    </Button>
                </BottomNavigationButtonContainer>
            </UpdateProxyPopupContainer>
        </>
    );
};
export default AddProxy;
